<script>
  export let link;
</script>

<style>
  .videoWrapper {
    overflow: hidden;
    position: relative;
    width: 100%;
  }

  .videoWrapper::after {
    padding-top: 56.25%;
    display: block;
    content: '';
  }

  .videoWrapper iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
</style>
<main style="min-height: 594px; padding: 0 20px;">
  <div class="row">
    <div class="videoWrapper">
      <iframe src={link} title="Video of the current tour stop" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope;"
        allowfullscreen></iframe>
    </div>
  </div>
</main>